import axios, { isAxiosError } from 'axios';
import { tokenManager } from './tokenManager';

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

api.interceptors.request.use(async (config) => {
  const token = await tokenManager.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await tokenManager.getToken(true);
      tokenManager.clearCache();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

/** Parses FastAPI-style `{ detail: string | ValidationError[] }` from failed axios responses. */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (!isAxiosError(error)) return fallback;
  const detail = (error.response?.data as { detail?: unknown } | undefined)?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    return detail
      .map((d: unknown) =>
        typeof d === 'object' && d !== null && 'msg' in d
          ? String((d as { msg: unknown }).msg)
          : JSON.stringify(d)
      )
      .join(', ');
  }
  return fallback;
}
